module.exports = require("buffer");


/*****************
 ** WEBPACK FOOTER
 ** external "buffer"
 ** module id = 75
 ** module chunks = 0
 **/